export default {
    inspection_pdf: 'Inspection Report (PDF)',
    inspection_xls: 'Inspection Report (Excel)',
    inspection_csv: 'Inspection Report (CSV)',
    job_pdf: 'Job Report (PDF)',
    job_summary_pdf: 'Job Summary Report (PDF)',
    inspection_summary_pdf: 'Inspection Summary Report (PDF)',
    all_jobs_xls: 'All Jobs Report (Excel)',
    all_jobs_pdf: 'All Jobs Report (PDF)',
    all_inspections_xls: 'All Inspections Report (Excel)',
    all_inspections_csv: 'All Inspections Report (CSV)',
    all_inspections_pdf: 'All Inspections Report (PDF)'
}
